// layout
export const SHOW_MENU = "SHOW_MENU"
export const SHOW_SETTINGS = "SHOW_SETTINGS"
export const SHOW_CHAPTER_LINKS = "SHOW_CHAPTER_LINKS"
export const SHOW_OTHER_LINKS = "SHOW_OTHER_LINKS"
export const SET_TEMPLATE = "SET_TEMPLATE"
export const SET_DARK = "SET_DARK"
// verseCard
export const SHOW_GREEK = "SHOW_GREEK"
export const SHOW_ENGLISH = "SHOW_ENGLISH"
export const SHOW_PARS_ID = "SHOW_PARS_ID"
export const SHOW_LEXN_ID = "SHOW_LEXN_ID"
export const SHOW_GREEK_COLOR = "SHOW_GREEK_COLOR"
export const EXPAND_ALL_VERSES = "EXPAND_ALL_VERSES"
export const LAST_VERSE_EXPANDED = "LAST_VERSE_EXPANDED"
// word
export const SET_BOOK = "SET_BOOK"
export const SET_SECTION_SHOWING = "SET_SECTION_SHOWING"
export const SET_PARS_IDS = "SET_PARS_IDS"
export const SET_PARS_TENSE = "SET_PARS_TENSE"
export const SET_PARS_VOICE = "SET_PARS_VOICE"
export const SET_PARS_MOOD = "SET_PARS_MOOD"
export const SET_PARS_PERSON = "SET_PARS_PERSON"
export const SET_PARS_CASE = "SET_PARS_CASE"
export const SET_PARS_GENDER = "SET_PARS_GENDER"
export const SET_PARS_NUMBER = "SET_PARS_NUMBER"
export const SET_LEXN_ID_LAST_VISITED = "SET_LEXN_ID_LAST_VISITED"
export const SET_LEXN_GREEK_LAST_VISITED = "SET_LEXN_GREEK_LAST_VISITED"
export const SET_SCROLL_POSITION = "SET_SCROLL_POSITION"
export const CLEAR_WORD_STATE = "CLEAR_WORD_STATE"
// flash cards
export const MIN_FREQ = "MIN_FREQ"
export const MAX_FREQ = "MAX_FREQ"
export const BOOK = "BOOK"
export const CHAPTER = "CHAPTER"
export const SHOW_ART = "SHOW ART"
export const SHOW_CONJ = "SHOW_CONJ"
export const SHOW_PRON = "SHOW_PRON"
export const SHOW_PREP = "SHOW_PREP"
export const SHOW_VERBS = "SHOW_VERBS"
export const SHOW_PART = "SHOW_PART"
export const SHOW_NOUNS = "SHOW_NOUNS"
export const SHOW_ADJ = "SHOW_ADJ"
export const SHOW_ADV = "SHOW_ADV"
export const SORT_VARIABLE = "SORT_VARIABLE"
